import { useMemo } from "react";

import type { IBillingPeriodItem, ICurrency } from "./types";
import { PaymentPeriod } from "./types";
import { getPriceByCurrency, numberWithCommas } from "./utils";

export const usePackagePrice = (
    periodItem: IBillingPeriodItem,
    currency: ICurrency,
    divideYearlyToMonths: boolean = true,
) => {
    const { price, period } = periodItem;
    const { code } = currency;

    return useMemo<string>(() => {
        const divisor = period === PaymentPeriod.ANNUAL && divideYearlyToMonths ? 12 : 1;
        const finalPrice = getPriceByCurrency(price, code).Price / divisor;
        return numberWithCommas(finalPrice.toFixed(0));
    }, [price, period, code]);
};
